export const addReturGoUrlParams = (email: string, orderId?: string) => {
  const url = new URL(window.location.pathname, window.location.origin);

  /** add query parameters in url  as described in the documentation
   * https://support.returngo.ai/advanced-styling-customization
   */
  if (orderId) {
    url.searchParams.append('orderId', orderId);
  }
  url.searchParams.append('email', email);

  /** update url without page scrolling */
  window.history.replaceState(null, '', url.href);
};

export const deleteReturGoUrlParams = ({
  email,
  orderId,
}: {
  email: boolean;
  orderId?: boolean;
}) => {
  if (!email && !orderId) {
    return;
  }

  const url = new URL(window.location.pathname, window.location.origin);
  if (orderId) {
    url.searchParams.delete('orderId');
  }

  if (email) {
    url.searchParams.delete('email');
  }

  /** update url without page scrolling */
  window.history.replaceState(null, '', url.href);
};
